import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import {
    getHelpCenterBanner,
    getHelpCenterTitleColor,
    getHelpCenterTopBarSplitFlag,
    getThemeColor,
} from 'state/selectors/help-center';
import { HeroElement } from './hero-element';

const selector = createSelector(
    getHelpCenterTopBarSplitFlag,
    getThemeColor,
    getHelpCenterTitleColor,
    getHelpCenterBanner,
    (hasTopBarBeenSplit, themeColor, helpCenterTitleColor, helpCenterBannerUrl) => ({
        hasTopBarBeenSplit,
        themeColor,
        helpCenterTitleColor,
        helpCenterBannerUrl,
    })
);

export default connect(selector, {})(HeroElement);
